type ResourceSlotWire = {
  archived?: boolean | null;
  resource_slot_assignments?: Array<{ booking_id?: number | null }> | null;
};

/** Booking ids on non-archived resource slot assignments (v1 production shape). */
export function extractBookingIdsFromProduction(production: {
  resource_slots?: unknown[] | null;
}): number[] {
  const ids = new Set<number>();
  for (const slot of production.resource_slots ?? []) {
    const { archived, resource_slot_assignments } = slot as ResourceSlotWire;
    if (archived) continue;
    for (const assignment of resource_slot_assignments ?? []) {
      if (assignment.booking_id) {
        ids.add(assignment.booking_id);
      }
    }
  }
  return Array.from(ids);
}
